import { mapDTO } from '@twistezo/ts-dto-mapper'
import { omit } from 'lodash'

import { Ability } from 'providers/casl'
import { fieldsToOmit } from 'providers/tanstack-query/utils'
import { minutesToMilliseconds } from 'utils/number'
import { Schema } from '../../../Sections/MultiAnchorSection/schema'
import { Variables } from './types'

type From = Schema
type To = Omit<Variables, 'workspaceId'>

export const toDTO = (from: From, ability: Ability): To =>
  mapDTO<From, To>({ from }).transform(
    ({
      counterStyle,
      customStyling,
      desktopAdDisplaysBeforeRefresh,
      desktopSingleAdViewTime,
      displayAfterUserInteraction,
      frequencyCappingEnabled,
      fullWidthMode,
      impressionLimit,
      mobileAdDisplaysBeforeRefresh,
      mobileSingleAdViewTime,
      showCloseButton,
      timeWindow,
    }: From): To => {
      const constantFields: Pick<
        To,
        | 'counterStyle'
        | 'customStyling'
        | 'desktopAdDisplaysBeforeRefresh'
        | 'desktopSingleAdViewTime'
        | 'displayAfterUserInteractionEnabled'
        | 'fullWidthModeEnabled'
        | 'mobileAdDisplaysBeforeRefresh'
        | 'mobileSingleAdViewTime'
        | 'showCloseButtonEnabled'
      > = {
        counterStyle,
        customStyling: JSON.parse(customStyling),
        desktopAdDisplaysBeforeRefresh: Number(desktopAdDisplaysBeforeRefresh),
        desktopSingleAdViewTime,
        displayAfterUserInteractionEnabled: displayAfterUserInteraction,
        fullWidthModeEnabled: fullWidthMode,
        mobileAdDisplaysBeforeRefresh: Number(mobileAdDisplaysBeforeRefresh),
        mobileSingleAdViewTime,
        showCloseButtonEnabled: showCloseButton,
      }

      const variableFields: Pick<To, 'frequencyCappingEnabled' | 'impressionLimit' | 'timeWindow'> =
        {
          frequencyCappingEnabled,
          impressionLimit,
          ...(timeWindow !== undefined ? { timeWindow: minutesToMilliseconds(timeWindow) } : {}),
        }

      return {
        ...constantFields,
        ...omit(
          variableFields,
          fieldsToOmit<To>({
            frequencyCappingEnabled: ability.cannot('update', 'GlobalSetupField-frequencyCapping'),
            impressionLimit: ability.cannot('update', 'GlobalSetupField-frequencyCapping'),
            timeWindow: ability.cannot('update', 'GlobalSetupField-frequencyCapping'),
          }),
        ),
      }
    },
  )
